/* Layout */
import Layout from '../../views/layout/Layout.vue'

const InstoryList = () => import(/* webpackChunkName: "home-configs" */ '@/views/home-config/instory-list')
const InstoryItemList = () => import(/* webpackChunkName: "home-configs" */ '@/views/home-config/instory-item-list')
const HelloBarList = () => import(/* webpackChunkName: "home-configs" */ '@/views/home-config/hello-bar-list')
const HelloBarDetail = () => import(/* webpackChunkName: "home-configs" */ '@/views/home-config/hello-bar-detail')
const HomepageTakeover = () => import(/* webpackChunkName: "home-configs" */ '@/views/home-config/homepage-takeover')

export default [
  {
    path: '/home-configs',
    component: Layout,
    redirect: 'noredirect',
    name: 'HomeConfigs',
    alwaysShow: true,
    meta: {
      title: 'Home Configs',
      icon: 'home',
    },
    children: [
      {
        path: 'instories',
        component: InstoryList,
        name: 'InstoryList',
        meta: {
          title: 'Instory',
          accessibleName: 'home-configs-instories',
        },
      },
      {
        path: 'instory-items/:id',
        component: InstoryItemList,
        props: true,
        name: 'InstoryItemList',
        hidden: true,
        meta: {
          title: 'Instory Item List',
          accessibleName: 'home-configs-instories',
        },
      },
      {
        path: 'hello-bars',
        component: HelloBarList,
        name: 'HelloBarList',
        meta: {
          title: 'Hello Bar',
          accessibleName: 'home-configs-hello-bars',
        },
      },
      {
        path: 'hello-bars/create',
        component: HelloBarDetail,
        name: 'HelloBarDetail',
        hidden: true,
        meta: {
          title: 'Hello Bar',
          accessibleName: 'home-configs-hello-bars',
        },
      },
      {
        path: 'hello-bars/:id',
        component: HelloBarDetail,
        props: true,
        name: 'HelloBarDetail',
        hidden: true,
        meta: {
          title: 'Hello Bar',
          accessibleName: 'home-configs-hello-bars',
        },
      },
      {
        path: 'homepage-takeover',
        component: HomepageTakeover,
        name: 'HomepageTakeover',
        meta: {
          title: 'Homepage Takeover',
          accessibleName: 'home-configs-homepage-takeover',
        },
      },
    ],
  },
]
